export default __webpack_public_path__ + "static/media/logo.52164e58.jpeg";